import { render, staticRenderFns } from "./ModalImportSpeakers.vue?vue&type=template&id=b349be3e&scoped=true"
import script from "./ModalImportSpeakers.vue?vue&type=script&lang=js"
export * from "./ModalImportSpeakers.vue?vue&type=script&lang=js"
import style0 from "./ModalImportSpeakers.vue?vue&type=style&index=0&id=b349be3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b349be3e",
  null
  
)

export default component.exports